<template>
  <v-container fluid class="menu-list mt-3">
    <v-row class="ma-0">
      <v-card width="100%" class="ma-1">
        <v-card-text>
          <v-row no-gutters>
            <v-col cols="12" md="6" class="d-flex justify-space-between justify-md-start">
              <v-btn to="/menu/add" color="success" class="button-shadow mr-3">
                <v-icon class="mr-2">mdi-plus</v-icon>
                Add
              </v-btn>
              <v-btn 
                v-show="item_seleted.length>0"
                :loading="isLoading"
                color="default" 
                class="button-shadow mb-2 mr-0 mr-sm-2"
                @click="copyMenu"
              >
                <v-icon class="mr-2">mdi-content-copy</v-icon>
                Copy
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="ma-1">
          <v-card-text>
            <v-data-table
              v-model="item_seleted"
              :loading="isReceiving || isDeleting"
              loading-text="Loading... Please wait"
              class="menus-table"
              show-select
              single-select
              item-key="_id"
              sort-by="createdAt"
              sort-desc
              :footer-props="footer"
              :headers="menuHeaders"
              :items="menus"
              :items-per-page="itemPerPage">
              <template v-slot:top>
                <v-dialog
                  v-model="isDeleteMenu"
                  width="500"
                >
                  <v-card>
                    <v-card-title>
                      Delete this Menu?
                    </v-card-title>
                    <v-card-text>
                      {{ delete_menu.menucode }}
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" outlined @click="isDeleteMenu = false">Cancel</v-btn>
                      <v-btn color="secondary" class="button-shadow" @click="deleteMenu(delete_menu)">Delete</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.menustatus="{ item }">
                <v-chip
                  :color="!item.menustatus ? 'primaryConst white--text' : 'secondaryConst white--text'"
                  small>
                  {{ item.menustatus }}
                </v-chip>
              </template>
              <template v-slot:item.createdAt="{ item }">
                {{ new Date(item.createdAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.updatedAt="{ item }">
                {{ new Date(item.updatedAt).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn icon color="primary" @click="editMenu(item)">
                  <v-icon>mdi-pencil-outline</v-icon>
                </v-btn>
                <v-btn icon color="primary" @click="deleteDialog(item)">
                  <v-icon>mdi-delete-outline</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'MenuList',
  data() {
    return {
      isDeleteMenu: false,
      isLoading: false,
      delete_menu: {},
      item_seleted: [],
      menuHeaders: [
        { text: 'Code', value: 'menucode'},
        { text: 'Name', value: 'menuname'},
        { text: 'Type', value: 'menutype'},
        { text: 'Create', value: 'createdAt' },
        { text: 'Update', value: 'updatedAt' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      footer: {'items-per-page-options': [500, 1000, 5000]},
      itemPerPage: 500,
    }
  },
  computed: {
    ...mapState('Menu', ['menus', 'isReceiving', 'isDeleting', 'idToDelete', 'isUpdating']),
  },
  created () {
    this.getMenusRequest()
  },
  methods: {
    ...mapActions('Menu', ["deleteMenuRequest","getMenusRequest","copyMenuRequest"]),
    async copyMenu(){
      this.isLoading = true;
      if(this.item_seleted==null || this.item_seleted.length==0) return;
      let selected = this.item_seleted[0];
      await this.copyMenuRequest(selected);
      this.isLoading = false;
      this.item_seleted=[];
    },
    editMenu(item) {
      this.$router.push({name: 'MenuEdit', params: item});
    },
    deleteMenu(item) {
      this.deleteMenuRequest({_id: item._id});
      this.isDeleteMenu = false;
    },
    deleteDialog(item) {
      this.isDeleteMenu = true;
      this.delete_menu = {_id: item._id,menucode: item.menucode};
    },
  },
}
</script>

<style src="./List.scss" lang="scss"></style>
